// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__9HNKq"};